import {ClsUtil} from '../../../util/cls-util';
import {INeodataMenu} from '../../../core/models/interfaces/generico-interface';
import {EnumMCGenerales, EnumMCPartida} from '../../../core/models/enum/enum-menu-contextual';
import {GenericoService} from '../../../core/services/generico.service';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {AppInfoService} from '../../../core/services/app-info.service';
import {
  ClsPeticionConsultarGralsCatalogos,
  ClsPeticionEliminarGralsCatalogos
} from '../../../core/models/peticiones/catalogos/cls-pr-catalogos';
import {
  DmSecundarioComponent
} from '../../../componentes/00-contenedores/docker-manager/dmseundario/dm-secundario.component';
import {
  ClsPartidasStorageZip, ClsPeticionDuplicarPartidas,
  ClsPeticionRegistraActualizaPartidas, ClsPeticionRenumerarRenglon,
  ClsPeticionUnirPpto,
  ClsRespuestaRegistraActualizaPartidas, ClsRespuestaRegistraActualizaPartidasDuplicadas
} from '../../../core/models/peticiones/cls-pr-partida';
import {EnumMasOpciones} from '../../../core/models/enum/enum-mas-opciones';
import {ClsObjGenerico} from '../../util/cls-obj-generico';
import {ClsObjCopiado} from '../copiado/cls-obj-copiado';
import {ClsPeticionPartidaWBS} from '../../../core/models/peticiones/cls-pr-calculo';
import { IgxTreeGridComponent } from '@infragistics/igniteui-angular/grids/tree-grid';
import { ITreeGridRecord } from '@infragistics/igniteui-angular/core';
import {ClsPeticionPresupuestos} from '../../../core/models/peticiones/cls-pr-generico';
import {ClsPartidasConceptosExpIns} from "../../../core/models/cls-presupuestos";
import {
  ClsArbolPartida,
  ClsConceptosPartida,
  ClsArbolNodo,
  ClsUnirPpto,
  ClsRenumerarRenglon
} from "../../../core/models/cls-partida";
import {ClsErrores} from "../../../core/models/cls-errores";
import {ClsNivel, ClsPartidasporNivel} from "../../../core/models/cls-reportes";
import {ClsCalculoPartidas, ClsWBSRenglon} from "../../../core/models/cls-calculo";
import {inject} from "@angular/core";
import {ClsGuardarConceptosPartida} from "../../../core/models/cls-concepto";
import {ClsPartida, ClsPartidaExistente, ClsPartidaExistente2} from "../../../core/models/cls-pegado";

export class ClsObjPresupuestoPartidas {
  public dataGridPartidas: ClsArbolPartida[];
  public dataPartidasConceptos: ClsPartidasConceptosExpIns = new ClsPartidasConceptosExpIns();
  public presupuesto: ClsConceptosPartida[] = [];
  private partidasFiltradas: ClsArbolPartida[] = [];
  // datos para calcular WBS
  public componenteArbol: IgxTreeGridComponent;
  // menu contextual
  private menus: INeodataMenu[] = [];
  // traer por bonches
  // private offset: number;
  // public mLPartidas: ClsArbolPartida[];

  private infPpto = inject(AppPresupuestosService);
  private servicioGen = inject(GenericoService);
  private infApp = inject(AppInfoService);
  constructor() {}

  // public inicializarComponenteComoMaestro(component: PartidasComponent, maestro: boolean) {
  //   if (maestro) {
  //     component.masOpcionesTG.arrayDatosAVer = [0, 3, 4, 5];
  //     component.masOpcionesTG.filtrarDatosAVer();
  //   } else {
  //     component.masOpcionesTG.arrayDatosAVer = [0, 1, 2, 3, 4, 5];
  //     component.masOpcionesTG.filtrarDatosAVer();
  //   }
  // }

  public validarCampos(newValor: ClsArbolPartida, oldValor: ClsArbolPartida, validarPartida: boolean = true): boolean {
    // Veririficar si hay que validar la partida
    if (validarPartida) {
      if (newValor.Partida !== oldValor.Partida) {
        return true;
      }
    }
    // Definir los campos a comparar
    const campos = [ 'PartidaAuxiliar', 'DescripcionPartida', 'DescripcionPartidaLarga', 'MetrosCuadrados'];
    // Comparar cada campo
    for (const campo of campos) {
      if (newValor[campo] !== oldValor[campo]) {
        return true;
      }
    }

    // Si no hubo cambios, retornar false
    return false;
  }

  public inicializarPartida(): ClsArbolPartida {
    return {
      IdPartidaPadre: BigInt('0'),
      IdPresupuestoPartida: BigInt('0'),
      Partida: '',
      PartidaAuxiliar: '',
      Renglon: 0,
      DescripcionPartida: '',
      DescripcionPartidaLarga: '',
      MetrosCuadrados: 1,
      PartidaWBS: '',
      CostoMoneda1: 0,
      PrecioMoneda1: 0,
      CostoMoneda2: 0,
      PrecioMoneda2: 0,
      JsonConceptos: ''
    };
  }
  /**
   * Este metodo descomprime partidas: ClsUtil.descomprimirArchivoBase64(partidasZIP, 'Partidas.txt');
   * @param partidasZIP recibe la data de partidas
   */
  public async crearObjPartidas(partidasZIP: string): Promise<ClsArbolPartida[]> {
    const partidas: ClsArbolPartida[] = [];
    try {
      const contenido: string = await ClsUtil.descomprimirArchivoBase64(partidasZIP, 'Partidas.txt');
      if (ClsUtil.esNulo(contenido)) {
        return partidas;
      }
      const objPartidas: string[] = ClsUtil.splitEnterNeo(contenido);
      objPartidas.forEach(item => {
        const partida: ClsArbolPartida = new ClsArbolPartida();
        const filas: string[] = ClsUtil.splitTabsNeo(item);
        partida.IdPartidaPadre = ClsUtil.bigintX(filas[0]);
        partida.IdPresupuestoPartida = ClsUtil.bigintX(filas[1]);
        partida.Partida = ClsUtil.cadenaX(filas[2]);
        partida.Renglon = Number(filas[3]);
        partida.PartidaAuxiliar = ClsUtil.cadenaX(filas[4]);
        partida.DescripcionPartida = ClsUtil.cadenaX(filas[5]);
        partida.DescripcionPartidaLarga = ClsUtil.cadenaX(filas[6]);
        partida.MetrosCuadrados = Number(filas[7]);
        partida.PartidaWBS = ClsUtil.cadenaX(filas[8]);
        partida.CostoMoneda1 = Number(filas[9]);
        partida.CostoMoneda2 = Number(filas[10]);
        partida.PrecioMoneda1 = Number(filas[11]);
        partida.PrecioMoneda2 = Number(filas[12]);
        if (isNaN(partida.MetrosCuadrados) || partida.MetrosCuadrados === 0) {
          partida.CostoMoneda1XM2 = 0;
          partida.CostoMoneda2XM2 = 0;
          partida.PrecioMoneda1XM2 = 0;
          partida.PrecioMoneda2XM2 = 0;
        } else {
          partida.CostoMoneda1XM2 = ClsUtil.redondearMoneda(partida.CostoMoneda1 / partida.MetrosCuadrados, this.infPpto.decimalredondearimporte);
          partida.CostoMoneda2XM2 = ClsUtil.redondearMoneda(partida.CostoMoneda2 / partida.MetrosCuadrados, this.infPpto.decimalredondearimporte);
          partida.PrecioMoneda1XM2 = ClsUtil.redondearMoneda(partida.PrecioMoneda1 / partida.MetrosCuadrados, this.infPpto.decimalredondearimporte);
          partida.PrecioMoneda2XM2 = ClsUtil.redondearMoneda(partida.PrecioMoneda2 / partida.MetrosCuadrados, this.infPpto.decimalredondearimporte);
        }
        partidas.push(partida);
      });
      return partidas;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public crearMenuContextual(partidaSeleccionado: ClsArbolPartida, esMaestro: boolean) {
    const translations: any = ClsUtil.getTranslations(['MENUCONTEXTUAL.NUEVA_PARTIDA', 'MENUCONTEXTUAL.AGREGAR_N_PARTIDA', 'MENUCONTEXTUAL.ELIMINAR_PARTIDA', 'MENUCONTEXTUAL.DUPLICAR_PARTIDAS'], this.infApp);
    const subLayout: INeodataMenu[] = [
      { id: EnumMasOpciones.Ajustar, descripcion: 'MENUCONTEXTUAL.ALTO_FILA', icono: 'wrap_text', disabled: false, divisor: true },
      { id: EnumMCGenerales.GuardarLayout, descripcion: 'MENUCONTEXTUAL.GUARDAR_LAYOUT', icono: 'save', disabled: false, divisor: false },
      { id: EnumMCGenerales.ReestablecerLayout, descripcion: 'MENUCONTEXTUAL.RESTABLECER_LAYOUT', icono: 'restore', disabled: false, divisor: false }
    ];
    const subNueva: INeodataMenu[] = [
      { id: EnumMCPartida.NuevaPartida, descripcion: `${translations['MENUCONTEXTUAL.NUEVA_PARTIDA']}'${partidaSeleccionado.Partida}'`, icono: 'add', disabled: esMaestro, divisor: false },
      { id: EnumMCPartida.NuevaPartidaRaiz, descripcion: 'MENUCONTEXTUAL.NUEVA_PARTIDA_R', icono: 'add_box', disabled: esMaestro, divisor: false },
      { id: EnumMCPartida.AgregarNPartidas, descripcion: `${translations['MENUCONTEXTUAL.AGREGAR_N_PARTIDA']}'${partidaSeleccionado.Partida}'`, icono: 'add_circle', disabled: esMaestro, divisor: false },
      { id: EnumMCPartida.AgregarNPartidasRaiz, descripcion: 'MENUCONTEXTUAL.AGREGAR_N_PARTIDA_R', icono: 'add_circle', disabled: esMaestro, divisor: true },
    ];
    return this.menus = [
      { id: '_nuevaPartida', descripcion: 'MENUCONTEXTUAL.PARTIDA_NUEVA', icono: 'add', disabled: esMaestro, divisor: true, subMenu: subNueva },
      { id: EnumMCPartida.RegenerarWBS, descripcion: 'MENUCONTEXTUAL.REGENERAR_WBS', icono: 'loop', disabled: esMaestro, divisor: false },
      { id: EnumMCGenerales.DetalleRegistro, descripcion: 'MENUCONTEXTUAL.DETALLE', icono: 'article', disabled: false, divisor: false },
      { id: EnumMCPartida.PegadoEspecial, descripcion: 'MENUCONTEXTUAL.PEGADO_ESPECIAL', icono: 'content_paste', disabled: esMaestro, divisor: false },
      { id: EnumMCPartida.EliminarPartida, descripcion: `${translations['MENUCONTEXTUAL.ELIMINAR_PARTIDA']}'${partidaSeleccionado.Partida}'`, icono: 'delete', disabled: esMaestro, divisor: false },
      { id: EnumMasOpciones.Actualizar, descripcion: 'MENSAJES.GRALS.ACTUALIZAR', icono: 'update', disabled: esMaestro, divisor: false  },
      { id: EnumMCGenerales.AplicarExpresion, descripcion: 'MENUCONTEXTUAL.APLICAR_EXPRESION', icono: 'functions', disabled: esMaestro, divisor: false },
      { id: EnumMCPartida.RenumerarRenglonPartidas, descripcion: 'MENUCONTEXTUAL.RENUMERAR_RENGLON_PARTIDAS', icono: 'repeat_one', disabled: esMaestro, divisor: false },
      { id: EnumMCPartida.RenumerarRenglon, descripcion: 'MENUCONTEXTUAL.RENUMERAR_RENGLON', icono: 'repeat_one', disabled: esMaestro, divisor: true },
      { id: EnumMCPartida.DuplicarNVecesLaPartida, descripcion: `${translations['MENUCONTEXTUAL.DUPLICAR_PARTIDAS']}'${partidaSeleccionado.Partida}'`, icono: 'content_copy', disabled: false, divisor: false },
      { id: EnumMCPartida.ExpandirTodo, descripcion: 'MENUCONTEXTUAL.EXPANDIR', icono: 'expand_more', disabled: false, divisor: false },
      { id: EnumMCPartida.ContraerTodo, descripcion: 'MENUCONTEXTUAL.COLAPSAR', icono: 'chevron_right', disabled: false, divisor: false },
      // { id: EnumMCGenerales.MarcarTodo, descripcion: 'MENUCONTEXTUAL.MARCAR_TODO', icono: 'check_box', disabled: false, divisor: false  },
      // { id: EnumMCGenerales.DesmarcarTodo, descripcion: 'MENUCONTEXTUAL.DESMARCAR_TODO', icono: 'remove_done', disabled: esMaestro, divisor: false },
      { id: EnumMCGenerales.DesmarcarTodoConceptos, descripcion: 'MENUCONTEXTUAL.DESMARCAR_TODO_CONCEPTOS', icono: 'remove_done', disabled: false, divisor: true },
      { id: 'layout', descripcion: 'MENUCONTEXTUAL.LAYOUT', icono: 'grid_on', disabled: false, divisor: false, subMenu: subLayout },
    ];
  }

  public buscarConceptosDeLaPartida(idPresupuestoPartidas: bigint[]): Map<bigint, ClsConceptosPartida[]> {
    let mapConceptos: Map<bigint, ClsConceptosPartida[]> = new Map<bigint, ClsConceptosPartida[]>();
    let mapPpto: Map<bigint, ClsConceptosPartida[]>;
    try {
      mapPpto = ClsUtil.crearMapPresupuestoIdPptoPartida(this.presupuesto, this.infPpto.decimalredondearimporte);
      idPresupuestoPartidas.forEach(idPptoPartida => {
        if (!mapConceptos.has(idPptoPartida)) {
          let conceptos: ClsConceptosPartida[] = mapPpto.get(idPptoPartida);
          conceptos = ClsUtil.esNulo(conceptos) ? [] : conceptos.sort((a, b) => {
            if (a.Renglon < b.Renglon) {
              return -1;
            }
            if (a.Renglon > b.Renglon) {
              return 1;
            }
            return 0;
          });
          mapConceptos.set(idPptoPartida, conceptos);
        }
      });
      return mapConceptos;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public buscarPartidaDeConceptos(conceptos: ClsConceptosPartida[]): ClsArbolPartida[] {
    let IdPresupuestoPartida: bigint = BigInt('0');
    this.partidasFiltradas = [];
    conceptos.forEach(concepto => {
      if (IdPresupuestoPartida !== concepto.IdPresupuestoPartida) {
        IdPresupuestoPartida = concepto.IdPresupuestoPartida;
        const partidaConcepto: ClsArbolPartida = this.dataPartidasConceptos.Partidas.find(item => concepto.IdPresupuestoPartida === item.IdPresupuestoPartida);
        this.buscarPartidasPadres(partidaConcepto);
      }
    });
    this.partidasFiltradas = this.partidasFiltradas.sort((a, b) => {
      return a.PartidaWBS < b.PartidaWBS ? -1 : a.PartidaWBS > b.PartidaWBS ? 1 : 0;
    });
    // this.partidasFiltradas = this.partidasFiltradas.sort((a, b) => {
    //   return a.IdPartidaPadre.toString().localeCompare(b.IdPartidaPadre.toString()) || a.PartidaWBS.localeCompare(b.PartidaWBS) || a.Renglon - b.Renglon;
    // });
    return this.partidasFiltradas;
  }

  private buscarPartidasPadres(partida: ClsArbolPartida) {
    if (ClsUtil.esNulo(partida.IdPartidaPadre)) {
      this.existePartida(partida);
      return;
    } else {
      this.existePartida(partida);
      const partida2 = this.dataPartidasConceptos.Partidas.find(item => item.IdPresupuestoPartida === partida.IdPartidaPadre);
      if (ClsUtil.esNulo(partida2)) {
        return;
      }
      this.buscarPartidasPadres(partida2);
    }
  }

  public crearListaIdsAEliminar(treeRow: ITreeGridRecord): bigint[] {
    const listaIds: bigint[] = [];
    listaIds.push(treeRow.key);
    if (treeRow.children.length > 0) {
      this.verificarHijos(treeRow.children, listaIds);
    }
    return listaIds;
  }

  private verificarHijos(hijos: ITreeGridRecord[], listaIds: bigint[]) {
    hijos.forEach(value => {
      listaIds.push(value.key);
      if (value.children.length > 0) {
        this.verificarHijos(value.children, listaIds);
      }
    });
  }

  private existePartida(partida: ClsArbolPartida) {
    const existe: ClsArbolPartida = this.partidasFiltradas.find(item => partida.IdPresupuestoPartida === item.IdPresupuestoPartida);
    if (ClsUtil.esNulo(existe)) {
      this.partidasFiltradas.push(partida);
    }
  }

  public nuevaPartidaEnRaiz(): string {
    let nuevo = '';
    let partStr = '';
    try {
      this.dataGridPartidas.forEach((item: ClsArbolPartida) => {
        partStr = item.Partida.trim().toUpperCase();
        if (partStr.length <= 3) {
          // console.log(partStr.match('^[A-Z]{' + partStr.length + '}$'));
          if (!ClsUtil.esNulo(partStr.match('^[A-Z]{' + partStr.length + '}$'))) {
            if (partStr.length > nuevo.length || (partStr.length === nuevo.length && partStr > nuevo)) {
              nuevo = partStr;
            }
          }
        }
      });
      if (nuevo.length === 0) {
        nuevo = 'A';
      } else if (nuevo.length === 1) {
        if (nuevo.charCodeAt(0) >= 90) {
          nuevo = 'AA';
        } else {
          nuevo = String.fromCharCode(nuevo.charCodeAt(0) + 1);
        }
      } else if (nuevo.length === 2) {
        if (nuevo.substring(1, 1).charCodeAt(0) >= 90) {
          if (nuevo.substring(0, 1).charCodeAt(0) >= 90) {
            nuevo = 'AAA';
          } else {
            nuevo = String.fromCharCode(nuevo.substring(0, 1).charCodeAt(0) + 1) + 'A';
          }
        } else {
          nuevo = nuevo.substring(0, 1) + String.fromCharCode(nuevo.substring(1, 1).charCodeAt(0) + 1);
        }
      } else if (nuevo.length === 3) {
        if (nuevo.substring(2, 1).charCodeAt(0) >= 90) {
          if (nuevo.substring(1, 1).charCodeAt(0) >= 90) {
            if (nuevo.substring(0, 1).charCodeAt(0) >= 90) {
              throw new Error('Imposible agregar más partidas a este nivel.');
            } else {
              nuevo = String.fromCharCode(nuevo.substring(0, 1).charCodeAt(0) + 1) + 'AA';
            }
          } else {
            nuevo = nuevo.substring(0, 1) + String.fromCharCode(nuevo.substring(1, 1).charCodeAt(0) + 1) + 'A';
          }
        } else {
          nuevo = nuevo.substring(0, 2) + String.fromCharCode(nuevo.substring(2, 1).charCodeAt(0) + 1);
        }
      }
    } catch (e) {
      throw new Error(e.message);
    }

    return nuevo;
  }

  public crearJsonCadena(conceptos: ClsConceptosPartida[]): string {
    try {
      const TAB = '\t';
      const ENTER = '\n';
      let JsonCadena = '';
      for (let i = 0; i < conceptos.length; i++) {
        const x = conceptos[i];
        JsonCadena += x.IdCatalogo.toString() + TAB;
        JsonCadena += x.Cantidad + TAB;
        JsonCadena += x.PorcentajeIndirectoEspecial + TAB;
        JsonCadena += x.Renglon + TAB;
        JsonCadena += Number(x.Marca).toString() + TAB;
        JsonCadena += x.CodigoAuxiliar + TAB;
        JsonCadena += x.Control + TAB;
        JsonCadena += Number(x.IndirectoEspecial).toString() + TAB;
        JsonCadena += x.PrecioMoneda1 + TAB;
        if (i === conceptos.length - 1) {
          JsonCadena += x.PrecioMoneda2;
        } else {
          JsonCadena += x.PrecioMoneda2 + ENTER;
        }
      }
      return JsonCadena;
    }
    catch (e) {
    }
  }

  public crearObjPartidasPegadoEspecial(datosPegados: any[], objGenerico: ClsObjGenerico, objCopiado: ClsObjCopiado, caracterSeparador: string): ClsArbolPartida[] {
    let partidaPadre: string;
    let partida: string;
    let partidas: string[];
    const arrayPartidas: ClsArbolPartida[] = [];
    objCopiado.mMapPartidas.clear();
    datosPegados.forEach(item => {
      const iniPartida: ClsArbolPartida = this.inicializarPartida();
      // campos para validar partidas
      const valorPartida: string = item[objGenerico.getTranslationsSubject('GRIDS.PARTIDAS.COL_PARTIDA')];
      const valorParAux: string = item[objGenerico.getTranslationsSubject('GRIDS.PARTIDAS.COL_PARTIDA_AUX')];
      const valorMetrosCuadrados: string = item[objGenerico.getTranslationsSubject('GRIDS.PARTIDAS.COL_METROS2')];
      const valorDes: string = item[objGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_DESCRIPCION')];
      const valorDesLarga: string = item[objGenerico.getTranslationsSubject('GRIDS.CONCEPTOS.COL_DESCRIPCION_LARGA')];
      partidaPadre = '<>';
      partida = '';
      partidas = [];
      if (!ClsUtil.esNulo(valorPartida)) {
        // obtener el caracter separado del ppto
        partidas = valorPartida.split(caracterSeparador);
        for (let i = 0; (i <= (partidas.length - 1)); i++) {
          partida = partidas[i];
          iniPartida.Partida = partida;
          const llave = `${partidaPadre.toUpperCase()}_${partida.toUpperCase()}`;
          if (!objCopiado.mMapPartidas.has(llave)) {
            iniPartida.DescripcionPartida = partida;
            iniPartida.DescripcionPartidaLarga = partida;
            if (i === (partidas.length - 1)) {
              if (!ClsUtil.esNulo(valorParAux) && valorParAux.trim().length > 0) {
                iniPartida.PartidaAuxiliar = valorParAux;
              }
              if (!ClsUtil.esNulo(valorDes) && valorDes.trim().length > 0) {
                iniPartida.DescripcionPartida = valorDes.substring(0,40);
                if (ClsUtil.esNulo(valorDesLarga)) {
                  iniPartida.DescripcionPartidaLarga = valorDes;
                }
              }
              if (!ClsUtil.esNulo(valorDesLarga) && valorDesLarga.trim().length > 0) {
                iniPartida.DescripcionPartidaLarga = valorDesLarga;
                if (ClsUtil.esNulo(valorDes)) {
                  iniPartida.DescripcionPartida = valorDesLarga.length > 40 ? valorDesLarga.substring(0, 40) : valorDesLarga;
                }
              }
              if (!ClsUtil.esNulo(valorMetrosCuadrados) && valorMetrosCuadrados.trim().length > 0) {
                iniPartida.MetrosCuadrados = ClsUtil.numberFormat(valorMetrosCuadrados);
              }
            }
            objCopiado.agregarPartidaSiNoExiste(partidaPadre, partida, iniPartida);
          }
          partidaPadre += `<${partida}>`;
        }
      }
    });
    // itero el mapa para crear obj para mandar al servicio
    objCopiado.mMapPartidas.forEach((value, key) => {
      arrayPartidas.push({PartidaPadre: key, Partida: value.Partida, Renglon: value.Renglon, PartidaAuxiliar: value.PartidaAuxiliar,
        DescripcionPartida: value.DescripcionPartida, DescripcionPartidaLarga: value.DescripcionPartidaLarga, MetrosCuadrados: value.MetrosCuadrados,
        PartidaWBS: value.PartidaWBS, PrecioMoneda1: value.PrecioMoneda1, CostoMoneda1: value.CostoMoneda1, PrecioMoneda2: value.PrecioMoneda2, CostoMoneda2: value.CostoMoneda2});
    });
    // itero el obj para mandar al servicio y creo los renglones
    arrayPartidas.forEach(value => {
      const llave: string = value.PartidaPadre.replace(`_${value.Partida.toUpperCase()}`, '');
      const dataFiltrado: ClsArbolPartida[] = arrayPartidas.filter(value1 => {
        const llave2: string = value1.PartidaPadre.replace(`_${value1.Partida.toUpperCase()}`, '');
        if (llave2.length === llave.length) {
          return value1;
        }
      });
      let renglon = 0;
      dataFiltrado.forEach(value1 => {
        renglon += 10;
        value1.Renglon = renglon;
      });
    });
    return arrayPartidas;
  }

  public async crearModificarNPartidas(catalogo: ClsArbolPartida[]): Promise<ClsArbolPartida[]> {
    let respuesta: ClsArbolPartida[];
    const objPeticion: ClsPeticionRegistraActualizaPartidas =  new ClsPeticionRegistraActualizaPartidas();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.Catalogo = catalogo;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'RegistraPartida');
      // modo offline
      if (!respuesta) {
        return [];
      }
      const addUpdate: ClsRespuestaRegistraActualizaPartidas = ClsUtil.parseJSONBig(respuesta);
      if (addUpdate?.Errores?.ErrorDescripcion !== '') {
        throw new Error(addUpdate.Errores.ErrorDescripcion);
      }
      return addUpdate.PartidasIds;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async crearNPartidasPegadoEspecial(catalogo: ClsArbolPartida[]): Promise<ClsArbolPartida[]> {
    let respuesta: ClsArbolPartida[];
    const objPeticion: ClsPeticionRegistraActualizaPartidas =  new ClsPeticionRegistraActualizaPartidas();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.Catalogo = catalogo;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'RegistraPartidaSinId');
      // modo offline
      if (!respuesta) {
        return [];
      }
      const add: ClsRespuestaRegistraActualizaPartidas = ClsUtil.parseJSONBig(respuesta);
      if (add?.Errores?.ErrorDescripcion !== '') {
        throw new Error(add.Errores.ErrorDescripcion);
      }
      return add.PartidasIds;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async borrarNPartidas(idsEliminar: bigint[]) {
    const objPeticion: ClsPeticionEliminarGralsCatalogos =  new ClsPeticionEliminarGralsCatalogos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.IdOrganizacion = this.infPpto.pptoSeleccionadoActivo.IdOrganizacion;
    objPeticion.ListaIds = idsEliminar;
    try {
      const respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'EliminarPresupuestosPartidas2021');
      // modo offline
      if (!respuesta) {
        return;
      }
      const eliminar: ClsErrores = ClsUtil.parseJSONBig(respuesta);
      if (eliminar?.ErrorDescripcion !== '') {
        throw new Error(eliminar.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async obtienerPartidasPorNivel(): Promise<ClsNivel[]> {
    let respuesta: ClsNivel[];
    const objPeticion: ClsPeticionPresupuestos =  new ClsPeticionPresupuestos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ObtienerPartidasPorNivel')
      // modo offline
      if (!respuesta) {
        return [];
      }
      const partida: ClsPartidasporNivel = ClsUtil.parseJSONBig(respuesta);
      if (partida?.Errores?.ErrorDescripcion !== '') {
        throw new Error(partida.Errores.ErrorDescripcion);
      }
      return partida.LsPartidasNivel ?? [];
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async registraActualizaPartidaWBS(partidaWBS: ClsWBSRenglon[], idPresupuesto: bigint) {
    const objPeticion: ClsPeticionPartidaWBS =  new ClsPeticionPartidaWBS();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = idPresupuesto;
    objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    objPeticion.LsPartidaWBS = partidaWBS;
    try {
      const respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'RegistraActualizaPartidaWBS');
      // modo offline
      if (!respuesta) {
        return;
      }
      const errores: ClsErrores = ClsUtil.parseJSONBig(respuesta);
      if (errores?.ErrorDescripcion !== '') {
        throw new Error(errores.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async validarObtenerPartidas(): Promise<ClsArbolPartida[]> {
    let objRespuesta: ClsArbolPartida[];
    try {
      objRespuesta = await this.obtenerTodasLasPartidas();
      return objRespuesta;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async obtenerTodasLasPartidas(): Promise<ClsArbolPartida[]> {
    let respuesta: ClsArbolPartida[];
    const objPeticion: ClsPeticionConsultarGralsCatalogos = new ClsPeticionConsultarGralsCatalogos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ObtienePartidasStorage')
      // modo offline
      if (!respuesta) {
        return [];
      }
      const partidas: ClsPartidasStorageZip = ClsUtil.parseJSONBig(respuesta);
      if (partidas?.Errores?.ErrorDescripcion !== '') {
        throw new Error(partidas.Errores.ErrorDescripcion);
      }
      return await this.crearObjPartidas(partidas.Partidas);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  // public async validaFechaConsultasPartidas(): Promise<boolean> {
  //   let respuesta: boolean;
  //   const objPeticion: ClsPeticionPresupuestos = new ClsPeticionPresupuestos();
  //   objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
  //   objPeticion.IdPresupuesto = ClsUtil.getPptoSelectedActivoMaestro(this.infPpto).IdPresupuesto;
  //   objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
  //   respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'validaFechaConsultasPartidas')
  //     .then(async (resp: any) => {
  //       const valida: ClsValidaFechasConsultas = ClsUtil.parseJSONBig(resp);
  //       try {
  //         if (valida.Errores.ErrorDescripcion !== '') {
  //           throw new Error(valida.Errores.ErrorDescripcion);
  //         } else {
  //           return valida.Estatus;
  //         }
  //       } catch (e) {
  //         throw new Error(e.message);
  //       }
  //     });
  //   return respuesta;
  // }

  public async calcularWBSPartidas(updatePartidas: boolean, arrayPartidas: ClsArbolPartida[], idPresupuesto: bigint) {
    const mapHPartidas: Map<bigint, ClsCalculoPartidas> = new Map<bigint, ClsCalculoPartidas>();
    const arrayRenglon: ClsWBSRenglon[] = [];
    const arrayEnvio: ClsWBSRenglon[] = [];
    let WBSS: string;
    let WBSN: number;
    // this.componenteArbol.markForCheck();
    // this.componenteArbol.cdr.detectChanges();
    const mapArbolPartida: Map<any, ITreeGridRecord> = this.componenteArbol.processedRecords;
    const countNivelPartida: Map<number, number> = ClsUtil.crearMapCountPartidaPorNivel(mapArbolPartida);
    try {
      arrayPartidas.forEach(par => {
        const IdPresupuestoPartida: bigint = ClsUtil.bigintX(par.IdPresupuestoPartida);
        const IdParPadre: bigint = ClsUtil.bigintX(par.IdPartidaPadre);
        mapHPartidas.set(IdPresupuestoPartida, {IdPartidaPadre:  IdParPadre, Renglon: par.Renglon, WBS: ''});
      });
      // iterar todas las que IdPartidaPadre = 0
      mapHPartidas.forEach((value, key) => {
        const IdPptoPartida: bigint = ClsUtil.bigintX(key);
        const IdParPadre: bigint = ClsUtil.bigintX(value.IdPartidaPadre);
        if (IdParPadre === BigInt('0')) {
          arrayRenglon.push({ IdPresupuestoPartida: IdPptoPartida, Renglon: value.Renglon});
        }
      });
      // ordenar ASC
      arrayRenglon.sort((a, b) => a.Renglon - b.Renglon);
      WBSN = 0;
      let partida: ClsCalculoPartidas;
      arrayRenglon.forEach((value, index) => {
        const llave: bigint = ClsUtil.bigintX(value.IdPresupuestoPartida);
        const nivel: number = mapArbolPartida.get(llave).level;
        const count: number = countNivelPartida.get(nivel);
        WBSN += 1;
        if (count <= 9) {
          WBSS = WBSN.toString();
        } else if (count >= 10 && count <= 99) {
          WBSS = ClsUtil.leftPad(WBSN, 2);
        } else if (count >= 100 && count <= 999) {
          WBSS = ClsUtil.leftPad(WBSN, 3);
        } else  {
          WBSS = ClsUtil.leftPad(WBSN, 4);
        }
        partida = mapHPartidas.get(value.IdPresupuestoPartida);
        partida.WBS = WBSS;
        mapHPartidas.set(value.IdPresupuestoPartida, partida);
        // calcular los hijos de IdPresupuestoPartida
        this.calcularHijosPartidas(value.IdPresupuestoPartida, WBSS, mapHPartidas, mapArbolPartida, countNivelPartida);
      });
      //  grabar datos WBS de las partidas [IdPresupuestoPartida, wbs] y validar si algo cambio
      arrayPartidas.forEach(par => {
        const llave: bigint = ClsUtil.bigintX(par.IdPresupuestoPartida);
        if (mapHPartidas.has(llave)) {
          const parNuevo: ClsCalculoPartidas =  mapHPartidas.get(llave);
          if (parNuevo.WBS !== par.PartidaWBS) {
            arrayEnvio.push({ IdPresupuestoPartida: llave, PartidaWBS: parNuevo.WBS});
          }
        }
      });
      if (arrayEnvio.length > 0) {
        await this.registraActualizaPartidaWBS(arrayEnvio, idPresupuesto);
      }
      // actualizar arbol de partidas, en caso de ser FALSE es posible que el metodo se este invocando desde otra parte
      // y no necesite actualizar de forma normal, es posible que el proceso este generando consultas y obtengan nuevamente todo
      // el ppto, ejemplo: Calculo
      if (updatePartidas) {
        this.componenteArbol.data.forEach(value => {
          const IdPresupuestoPartida: bigint = ClsUtil.bigintX(value.IdPresupuestoPartida);
          if (mapHPartidas.has(IdPresupuestoPartida)) {
            const par: ClsCalculoPartidas = mapHPartidas.get(IdPresupuestoPartida);
            value.PartidaWBS = par.WBS;
          }
        });
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private calcularHijosPartidas(idPartidaPadre: bigint, wbsPadre: string, mapHPartidas: Map<bigint, ClsCalculoPartidas>,
                                mapArbolPartida: Map<any, ITreeGridRecord>, countNivelPartida: Map<number, number>) {
    let mapRenglon: ClsWBSRenglon[] = [];
    let WBSS: string;
    let WBSN: number;
    try {
      mapHPartidas.forEach((value, key) => {
        const IdPptoPartida: bigint = ClsUtil.bigintX(key);
        const IdParPadre: bigint = ClsUtil.bigintX(value.IdPartidaPadre);
        if (IdParPadre === idPartidaPadre) {
          mapRenglon.push({ IdPresupuestoPartida: IdPptoPartida, Renglon: value.Renglon});
        }
      });
      // ordenar ASC
      mapRenglon.sort((a, b) => a.Renglon - b.Renglon);
      WBSN = 0;
      let partida: ClsCalculoPartidas;
      mapRenglon.forEach((value, index) => {
        let llave: bigint = ClsUtil.bigintX(value.IdPresupuestoPartida);
        let nivel: number = mapArbolPartida.get(llave).level;
        let count: number = countNivelPartida.get(nivel);
        WBSN += 1;
        if (count <= 9) {
          WBSS = wbsPadre + '.' + WBSN.toString();
        } else if (count >= 10 && count <= 99) {
          WBSS = WBSS = wbsPadre + '.' + ClsUtil.leftPad(WBSN, 2);
        } else if (count >= 100 && count <= 999) {
          WBSS = WBSS = wbsPadre + '.' + ClsUtil.leftPad(WBSN, 3);
        } else  {
          WBSS = WBSS = wbsPadre + '.' + ClsUtil.leftPad(WBSN, 4);
        }
        partida = mapHPartidas.get(value.IdPresupuestoPartida);
        partida.WBS = WBSS;
        mapHPartidas.set(value.IdPresupuestoPartida, partida);
        // calcular los hijos de IdPresupuestoPartida
        this.calcularHijosPartidas(value.IdPresupuestoPartida, WBSS, mapHPartidas, mapArbolPartida, countNivelPartida);
      });
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async borrarIDNPartidas(idsEliminar: bigint[]) {
    const dmSecundario: DmSecundarioComponent = this.infPpto.dmPrincipal.dmSecundarioPptoActivo;
    idsEliminar.forEach(idPartida => {
      const index: number = this.infPpto.pptoActivoCompletoJSON.Partidas.findIndex(insumo => insumo.IdPresupuestoPartida === idPartida);
      this.infPpto.pptoActivoCompletoJSON.Partidas.splice(index, 1);
    });
    dmSecundario.Ppto.dataPartidasConceptos.Partidas = this.infPpto.pptoActivoCompletoJSON.Partidas;
    if (!ClsUtil.esNulo(dmSecundario.PptoCompleto)) {
      dmSecundario.PptoCompleto.dataPptoCompleto = ClsUtil.mergePartidasConceptos(dmSecundario.Ppto.dataPartidasConceptos, this.infPpto);
      dmSecundario.PptoCompleto.gridPptoCompleto.data = dmSecundario.PptoCompleto.dataPptoCompleto;
      dmSecundario.PptoCompleto.gridPptoCompleto.markForCheck();
      dmSecundario.PptoCompleto.gridPptoCompleto.cdr.detectChanges();
    }
  }

  public actualizarListaPpto(partidas: ClsArbolPartida[]) {
    // actualizar lista de partidas - infPpto
    this.infPpto.pptoActivoCompletoJSON.Partidas = partidas;
  }

  public agregarListaPpto(partida: ClsArbolPartida) {
    // agregar una partida a la lista de partidas - infPpto
    this.infPpto.pptoActivoCompletoJSON.Partidas.push(partida);
  }

  public obtenerRowsOrdenados(ids: bigint[], treeGridPartidas: IgxTreeGridComponent): ITreeGridRecord[] {
    const rows: ITreeGridRecord[] = [];

    for (const id of ids) {
      const row = treeGridPartidas.getRowByKey(id);
      if (!ClsUtil.esNulo(row)) {
        rows.push(row.treeRow);
      }
    }

    return rows.sort((a, b) => {
      const nivelDiff = a.level - b.level;
      return nivelDiff !== 0 ? nivelDiff : a.data.Renglon - b.data.Renglon;
    });
  }
  public obtenerPartidasAntesDeSerBorrados(ids: bigint[], treeGridPartidas: IgxTreeGridComponent): ITreeGridRecord[] {
    const rows: ITreeGridRecord[] = [];
    for (const id of ids) {
      const row = treeGridPartidas.getRowByKey(id);
      if (!ClsUtil.esNulo(row)) {
        rows.push(row.treeRow);
      }
    }

    return rows;
  }

  public obtenerPartidasNoEncontradas(ids: bigint[], treeGridPartidas: IgxTreeGridComponent, rows: ITreeGridRecord[]): string[] {
    const partidasNoEncontradas: string[] = [];

    for (const id of ids) {
      const existe = treeGridPartidas.data.some(p => p.IdPresupuestoPartida === id);
      if (!existe) {
        const partida = rows.filter(value => value.key === id)[0];
        if (!ClsUtil.esNulo(partida)) {
          partidasNoEncontradas.push(partida.data.Partida);
        }
      }
    }

    return partidasNoEncontradas;
  }

  public async modificarListaPpto(partida: ClsArbolPartida) {
    // obtener el codigo de todas las partidas para ser actualizadas
    const par: ClsArbolPartida = this.infPpto.pptoActivoCompletoJSON.Partidas.find(buscar => buscar.IdPresupuestoPartida === partida.IdPresupuestoPartida);
    if (!ClsUtil.esNulo(par)) {
      par.DescripcionPartida = partida.DescripcionPartida;
      par.DescripcionPartidaLarga = partida.DescripcionPartidaLarga;
      par.PartidaAuxiliar = partida.PartidaAuxiliar;
      par.MetrosCuadrados = partida.MetrosCuadrados;
    }
  }
  // region Duplicar partida
  public async duplicarPartida(catalogo: ClsArbolPartida[], partidaSeleccionada: ClsArbolPartida, partidasConceptos: ClsGuardarConceptosPartida[], nveces: number) {
    const objPeticion: ClsPeticionDuplicarPartidas =  new ClsPeticionDuplicarPartidas();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.IdOrganizacion = this.infPpto.pptoSeleccionadoActivo.IdOrganizacion;
    objPeticion.Catalogo = catalogo;
    objPeticion.PartidaSeleccionada = partidaSeleccionada;
    objPeticion.PartidasConceptos = partidasConceptos;
    objPeticion.VecesADuplicar = nveces;
    const x = ClsUtil.stringifyJSONBig(objPeticion);
    await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'DuplicarPartidas')
      .then(async (resp: any) => {
        const addUpdate: ClsRespuestaRegistraActualizaPartidasDuplicadas = ClsUtil.parseJSONBig(resp);
        try {
          if (addUpdate.Errores.ErrorDescripcion !== '') {
            throw new Error(addUpdate.Errores.ErrorDescripcion);
          }
          return addUpdate.Partidas;
        } catch (e) {
          throw new Error(e.message);
        }
      });
  }
  // end region

  // region Unir Ppto
  public async unirPpto(catalogo: ClsUnirPpto[], borrarPpto: boolean) {
    const objPeticion: ClsPeticionUnirPpto =  new ClsPeticionUnirPpto();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.IdOrganizacion = this.infPpto.pptoSeleccionadoActivo.IdOrganizacion;
    objPeticion.Catalogo = catalogo;
    objPeticion.BorrarPpto = borrarPpto;
    const x = ClsUtil.stringifyJSONBig(objPeticion);
    await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'UnirPresupuesto')
      .then(async (resp: any) => {
        const addUpdate: any = ClsUtil.parseJSONBig(resp);
        try {
          if (addUpdate.ErrorDescripcion !== '') {
            throw new Error(addUpdate.ErrorDescripcion);
          }
          return addUpdate.Partidas;
        } catch (e) {
          throw new Error(e.message);
        }
      });
  }

  public generarJerarquia(data: any[], caracterSeparador: string, mapPartidas: Map<string, { descripcion: string, desCompleta: string }>): ClsPartida[] {
    const nodos: Map<string, ClsPartida> = new Map();
    const raiz: ClsPartida[] = [];
    let nextId = 1n;

    for (const item of data) {
      const partes = item.Partida.split(caracterSeparador);
      let padreId = 0n; // ID del nodo raíz

      for (let i = 0; i < partes.length; i++) {
        const nombrePartida = partes[i];
        const claveNodo = partes.slice(0, i + 1).join(caracterSeparador);

        if (!nodos.has(claveNodo)) {
          const nuevoNodo: ClsPartida = {
            Id: nextId++,
            IdPadre: padreId,
            nombre: nombrePartida,
            descripcion: mapPartidas.get(claveNodo)?.descripcion ?? nombrePartida,
            descripcionLarga: mapPartidas.get(claveNodo)?.desCompleta ?? nombrePartida,
            Conceptos: [],
            children: [],
          };
          nodos.set(claveNodo, nuevoNodo);

          // Si no es el nodo raíz, lo agregamos como hijo de su padre
          if (padreId !== 0n) {
            const nodoPadre = nodos.get(partes.slice(0, i).join(caracterSeparador));
            if (nodoPadre && !nodoPadre.children?.some(child => child.Id === nuevoNodo.Id)) {
              nodoPadre.children = [...(nodoPadre.children || []), nuevoNodo];
            }
          } else {
            raiz.push(nuevoNodo); // Si es raíz, lo agregamos al array raíz
          }
        }
        padreId = nodos.get(claveNodo)!.Id; // El ID del nodo actual se convierte en el ID del padre para la siguiente iteración

        // Si es el último segmento de la Partida, agregamos el concepto al nodo actual
        if (i === partes.length - 1) {
          const nodoActual = nodos.get(claveNodo)!;
          const codigo = item["Código"];
          const desCompleta = item["Descripción completa"];
          const idCat = this.infPpto.pptoActivoCompletoJSON.CatExpIns.find(insumo => insumo.Codigo.toUpperCase() === codigo.toUpperCase())?.IdCatalogo;
          const concepto = {
            IdCatalogo: idCat ? idCat : 0n,
            Codigo: codigo,
            Cantidad: Number(item.Cantidad),
            Unidad: item.Unidad,
            DescripcionCompleta: desCompleta,
          };
          nodoActual.Conceptos.push(concepto);
        }
      }
    }

    // Eliminamos los arrays 'children' vacíos para una estructura más limpia (opcional)
    function limpiarChildren(nodo: ClsPartida) {
      if (nodo.children && nodo.children.length === 0) {
        delete nodo.children;
      } else if (nodo.children) {
        nodo.children.forEach(limpiarChildren);
      }
    }

    raiz.forEach(limpiarChildren);

    return raiz;
  }

  public construirArbol(listaPlana: ClsArbolPartida[]): ClsArbolNodo[] {
    const arbol: ClsArbolNodo[] = [];
    // Usa un Map para indexar todos los nodos por su IdPartida.
    const mapaNodos = new Map<bigint, ClsArbolNodo>();

    // PASO 1: Inicializar todos los nodos del árbol y llenar el Map.
    for (const item of listaPlana) {
      // Copiamos el objeto y le agregamos el array de 'children' vacío.
      const nodo: ClsArbolNodo = { ...item, Children: [] };
      mapaNodos.set(nodo.IdPresupuestoPartida, nodo);
    }

    // PASO 2: Conectar hijos a sus padres.
    // Recorremos el Map (que contiene todos los nodos inicializados).
    for (const nodo of mapaNodos.values()) {
      const parentId = nodo.IdPartidaPadre;

      // Si tiene un padre (IdPartidaPadre > 0), lo adjuntamos a él.
      if (parentId !== 0n && mapaNodos.has(parentId)) {
        const padre = mapaNodos.get(parentId);
        // Pusheamos el nodo actual (hijo) al array 'children' de su padre.
        padre?.Children?.push(nodo);
      }
      // Si no tiene padre (IdPartidaPadre === 0), es un nodo raíz.
      else {
        arbol.push(nodo);
      }
    }

    // El array 'arbol' ahora contiene solo los nodos raíz, y todos los demás están
    // anidados dentro de su propiedad 'children'.
    return arbol;
  }

  public asignarIdExistente2(nuevaJerarquia: ClsArbolNodo[], jerarquiaExistente: ClsArbolNodo[], selectedConcepts:  Map<bigint, ClsConceptosPartida[]>): void {
    function compararNodos(nuevoNodo: ClsPartidaExistente2, nodoExistente: any): boolean {
      return nuevoNodo.Partida.toUpperCase() === nodoExistente.Partida.toUpperCase();
    }

    function recorrerYAsignar(nuevosNodos: ClsArbolNodo[], nodosExistentes: ClsArbolNodo[]): void {
      for (const nuevoNodo of nuevosNodos) {
        const nodoExistenteCoincidente = nodosExistentes.find((existente) =>
          compararNodos(nuevoNodo, existente)
        );

        if (nodoExistenteCoincidente) {
          const conceptos = selectedConcepts.get((nuevoNodo as ClsPartidaExistente2).IdPresupuestoPartida);
          if (conceptos) {
            conceptos.forEach(x => {
              x.IdPresupuestoPartida = nodoExistenteCoincidente.IdPresupuestoPartida;
            });
            selectedConcepts.set(nodoExistenteCoincidente.IdPresupuestoPartida, conceptos);
          }
          (nuevoNodo as ClsPartidaExistente2).IdPresupuestoPartida = nodoExistenteCoincidente.IdPresupuestoPartida;
          (nuevoNodo as ClsPartidaExistente2).EsNuevo = false;
          (nuevoNodo as ClsPartidaExistente2).Renglon = nodoExistenteCoincidente.Renglon;

          if (nuevoNodo.Children && nodoExistenteCoincidente.Children) {
            nuevoNodo.Children.forEach(x => x.IdPartidaPadre = nuevoNodo.IdPresupuestoPartida);
            recorrerYAsignar(nuevoNodo.Children, nodoExistenteCoincidente.Children);
          }
        } else {
          (nuevoNodo as ClsPartidaExistente2).EsNuevo = true;
        }
      }
    }

    recorrerYAsignar(nuevaJerarquia, jerarquiaExistente);
  }
  public asignarIdExistente(nuevaJerarquia: any[], jerarquiaExistente: any[]): void {
    function compararNodos(nuevoNodo: ClsPartidaExistente, nodoExistente: any): boolean {
      return nuevoNodo.nombre.toUpperCase() === nodoExistente.data.Partida;
    }

    function recorrerYAsignar(nuevosNodos: ClsPartida[], nodosExistentes: any[]): void {
      for (const nuevoNodo of nuevosNodos) {
        const nodoExistenteCoincidente = nodosExistentes.find((existente) =>
          compararNodos(nuevoNodo, existente)
        );

        if (nodoExistenteCoincidente) {
          (nuevoNodo as ClsPartidaExistente).Id = nodoExistenteCoincidente.data.IdPresupuestoPartida;
          (nuevoNodo as ClsPartidaExistente).nuevo = false;
          (nuevoNodo as ClsPartidaExistente).Renglon = nodoExistenteCoincidente.data.Renglon;

          if (nuevoNodo.children && nodoExistenteCoincidente.children) {
            nuevoNodo.children.forEach(x => x.IdPadre = nuevoNodo.Id);
            recorrerYAsignar(nuevoNodo.children, nodoExistenteCoincidente.children);
          }
        } else {
          // Opcional: Puedes agregar lógica aquí si no se encuentra un nodo coincidente
          (nuevoNodo as ClsPartidaExistente).nuevo = true;
        }
      }
    }

    recorrerYAsignar(nuevaJerarquia, jerarquiaExistente);
  }

  public obtenerPartidasHijas(nodo: ClsPartida) {
    let lista: any[] = [];
    const recorrer = (nodo: ClsPartida) => {
      lista.push({
        IdPresupuestoPartida: nodo.Id,
        Partida: nodo.nombre,
        IdPartidaPadre: nodo.IdPadre,
        EsNuevo: ClsUtil.esNulo(nodo.nuevo) ? true : nodo.nuevo,
        Descripcion: nodo.descripcion,
        DescripcionCompleta: nodo.descripcionLarga,
        Conceptos: nodo.Conceptos,
        Renglon: nodo.Renglon
      });
      // Llamamos recursivamente a cada partida hija
      nodo.children?.forEach(recorrer);
    }
    recorrer(nodo);
    return lista;
  }

  public obtenerPartidasHijas2(nodo) {
    let lista: any[] = [];
    const recorrer = (nodo) => {
      lista.push(nodo);
      // Llamamos recursivamente a cada partida hija
      nodo.Children?.forEach(recorrer);
    }
    recorrer(nodo);
    return lista;
  }
  // endregion
  //#region RenumerarRenglon
  public async renumerarRenglonPartidas(partidas: ClsRenumerarRenglon[]) {
    const objPeticion: ClsPeticionRenumerarRenglon =  new ClsPeticionRenumerarRenglon();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.IdOrganizacion = this.infPpto.pptoSeleccionadoActivo.IdOrganizacion;
    objPeticion.Partidas = partidas;
    const x = ClsUtil.stringifyJSONBig(objPeticion);
    await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'RenumerarRenglon')
      .then(async (resp: any) => {
        const addUpdate: any = ClsUtil.parseJSONBig(resp);
        try {
          if (addUpdate.ErrorDescripcion !== '') {
            throw new Error(addUpdate.ErrorDescripcion);
          }
        } catch (e) {
          throw new Error(e.message);
        }
      });
  }
  //#endregion
  //#region Traduccion
  public getTranslationsQuestionBorrar(partida: string): string {
    return ClsUtil.getTranslations(['MENSAJES.QUESTION.ELIMINAR_PARTIDA'], this.infApp)['MENSAJES.QUESTION.ELIMINAR_PARTIDA'].toString().replace('{0}', partida);
  }
  public getTranslationsQuestionBorrarNPartidas(partida: string): string {
    return ClsUtil.getTranslations(['MENSAJES.QUESTION.ELIMINAR_PARTIDAS'], this.infApp)['MENSAJES.QUESTION.ELIMINAR_PARTIDAS'].toString().replace('{0}', partida);
  }
  //#endregion
}
